import PropTypes from 'prop-types';
import styles from './FJCommunityWorkItem.module.less';
import FJAiRecreateIcon from '../../../../assets/svg/community/ai-recreate.svg?react';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJImage from '../../../../common/components/FJImage/FJImage';
import FJUtil from '../../../../util/FJUtil';
import FJCommunityMedia from '../FJCommunityMedia/FJCommunityMedia';
import FJDownloadIcon from '../../../../assets/svg/community/download.svg?react';
import FJDeleteIcon from '../../../../assets/svg/community/delete.svg?react';
import FJTrimVideoEditIcon from '../../../../assets/svg/community/trim-video-Edit.svg?react';
import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox';
import classNames from 'classnames';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip';
import FJConstant from '../../../../constants/FJConstant';
import FJPrivacySetting from '../FJPrivacySetting/FJPrivacySetting';
import { useState } from 'react';
import FJShareSettingIcon from '../../../../assets/svg/community/share-setting.svg?react';
import FJHistoryVideoEditIcon from '../../../../assets/svg/video-history.svg?react';
import FJLikeIconComponent from '../FJLikeIconComponent/FJLikeIconComponent';
import FJCommunityUtil from '../../../../util/FJCommunityUtil';
import { useMemo } from 'react';

const FJCommunityWorkItem = props => {
    const {
        item = {},
        onRecreateClick,
        onLikeClick,
        onClick,
        isMultipleSelect,
        isSelected,
        onDownloadClick,
        onShareSettingClick,
        onVideoEditClick,
        onDeleteClick,
        onSelected,
        guestUserInfo,
        active,
    } = props;
    const {
        imgUrl = '',
        videoUrl = '',
        mediaType,
        avatar,
        username,
        likeNum,
        isLike,
        originalImages,
        // width,
        // height,
        workType,
        coverImg = '',
        coverVideo = '',
        shareKey,
        privacyStatus,
        isSupportCommunity,
        userKey,
        communityId,
    } = item;
    const [isFocused, setIsFocused] = useState(false);

    const _onUserClick = e => {
        FJUtil.forbidEvent(e);
        FJCommunityUtil.openUserPage(userKey);
    };
    const _onRecreateClick = e => {
        FJUtil.forbidEvent(e);
        onRecreateClick && onRecreateClick(item);
    };

    const _onClick = e => {
        FJUtil.forbidEvent(e);
        if (isMultipleSelect) {
            onSelected && onSelected(item, !isSelected);
        } else {
            onClick && onClick(item);
        }
    };
    const _onDownloadClick = e => {
        FJUtil.forbidEvent(e);
        onDownloadClick && onDownloadClick(item);
    };
    const _onPrivacySettingChange = (value, callback) => {
        onShareSettingClick && onShareSettingClick(value, callback);
    };

    const _onVideoEditClick = e => {
        FJUtil.forbidEvent(e);
        onVideoEditClick && onVideoEditClick(item);
    };
    const _onDeleteClick = e => {
        FJUtil.forbidEvent(e);
        onDeleteClick && onDeleteClick(item);
    };
    const _onSelected = (bool, e) => {
        FJUtil.forbidEvent(e);
        onSelected && onSelected(item, bool);
    };

    const _renderInteractionContent = () => {
        if (workType === FJConstant.MY_CREATIONS_WORK && !isSupportCommunity) return null;
        if (
            (workType === FJConstant.SHARED_WORK ||
                workType === FJConstant.MY_CREATIONS_WORK ||
                workType === FJConstant.MY_CREATIONS_DETAIL_WORK) &&
            !guestUserInfo.guestMode
        ) {
            const hideDelete = workType === FJConstant.SHARED_WORK || workType === FJConstant.MY_CREATIONS_WORK;
            const hideMultipleSelect = workType === FJConstant.MY_CREATIONS_WORK;
            const hideDownload = workType === FJConstant.MY_CREATIONS_WORK;
            const hidePrivacySetting = !isSupportCommunity;
            const hideVideoEditor = workType === FJConstant.MY_CREATIONS_WORK;
            const hideFooter =
                workType === FJConstant.MY_CREATIONS_DETAIL_WORK || workType === FJConstant.MY_CREATIONS_WORK;

            return (
                <div
                    className={classNames(styles.my_work_item_content_box, {
                        [styles.multiple_select]: isMultipleSelect,
                        [styles.focused]: isFocused,
                    })}
                >
                    <div className={classNames(styles.header)}>
                        <div className={styles.header_left}>
                            {!hideMultipleSelect && (
                                <FJCheckBox
                                    selected={isSelected}
                                    dataChange={_onSelected}
                                    className={classNames(styles.checkbox, {
                                        [styles.checkbox_show]: isSelected,
                                    })}
                                />
                            )}
                        </div>
                        <div className={styles.header_right}>
                            {!hideDownload && (
                                <FJToolTip title='download'>
                                    <div className={styles.icon_box} onClick={_onDownloadClick}>
                                        <FJDownloadIcon />
                                    </div>
                                </FJToolTip>
                            )}
                            {!hidePrivacySetting && (
                                <FJPrivacySetting
                                    value={privacyStatus}
                                    onChange={_onPrivacySettingChange}
                                    onShow={() => setIsFocused(true)}
                                    onHide={() => setIsFocused(false)}
                                    shareKey={shareKey}
                                    isNeedBindWheelEvent={true}
                                    communityId={communityId}
                                    placement='rightTop'
                                    offsetTop={-100}
                                    offsetLeft={6}
                                    renderTrigger={({ ref, onClick }) => {
                                        const _onClick = e => {
                                            e.stopPropagation();
                                            onClick(e);
                                        };
                                        return (
                                            <FJToolTip title='visibility'>
                                                <div
                                                    className={styles.icon_box}
                                                    ref={ref}
                                                    onClick={e => {
                                                        _onClick(e);
                                                    }}
                                                >
                                                    <FJShareSettingIcon />
                                                </div>
                                            </FJToolTip>
                                        );
                                    }}
                                />
                            )}
                            {!hideVideoEditor && (
                                <FJToolTip title='video-editor'>
                                    <div className={styles.icon_box} onClick={_onVideoEditClick}>
                                        {isSupportCommunity ? <FJTrimVideoEditIcon /> : <FJHistoryVideoEditIcon />}
                                    </div>
                                </FJToolTip>
                            )}
                            {!hideDelete && (
                                <FJToolTip title='delete'>
                                    <div className={styles.icon_box} onClick={_onDeleteClick}>
                                        <FJDeleteIcon />
                                    </div>
                                </FJToolTip>
                            )}
                        </div>
                    </div>
                    {!hideFooter && (
                        <div className={styles.footer}>
                            <FJLikeIconComponent isLike={isLike} likeNum={likeNum} onLikeClick={onLikeClick} />
                        </div>
                    )}
                </div>
            );
        }
        return (
            <div className={styles.content_box}>
                <div className={styles.header}>
                    <div className={styles.header_left} onClick={_onUserClick}>
                        <img className={styles.avatar} src={avatar} alt={username} />
                        <div className={styles.username}>{username}</div>
                    </div>
                    <div className={styles.header_right}>
                        <FJLikeIconComponent isLike={isLike} likeNum={likeNum} onLikeClick={onLikeClick} />
                    </div>
                </div>
                <div className={styles.footer}>
                    <div className={styles.footer_left}>
                        <FJButton
                            className={styles.recreate_btn}
                            type={FJButtonType.GRADIENT}
                            text={FJLocalStore._('recreate')}
                            rightIcon={<FJAiRecreateIcon className={styles.recreate_icon} />}
                            onClick={_onRecreateClick}
                            textClassName={styles.recreate_btn_text}
                        />
                    </div>
                    {originalImages && originalImages.length > 0 && (
                        <div className={styles.footer_right}>
                            <FJImage
                                imgSrc={originalImages[0]}
                                boxClassName={styles.original_image_box}
                                isShowLoading={false}
                                imgClassName={styles.original_image}
                                addRefreshEvent={true}
                                // style={_originalSize}
                            />

                            {originalImages.length > 1 && (
                                <div className={styles.original_images_num}>+{originalImages.length - 1}</div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const autoPlay = useMemo(() => {
        return workType === FJConstant.HOME_WORK || workType === FJConstant.COMMUNITY_WORK;
    }, [workType]);
    if (!active) return null;

    return (
        <div className={styles.box} onClick={_onClick}>
            <FJCommunityMedia
                mediaType={mediaType}
                coverVideo={coverVideo}
                coverImg={coverImg}
                videoUrl={videoUrl}
                imgUrl={imgUrl}
                autoPlay={autoPlay}
            >
                {_renderInteractionContent()}
            </FJCommunityMedia>
        </div>
    );
};

FJCommunityWorkItem.propTypes = {
    item: PropTypes.object,
    onRecreateClick: PropTypes.func,
    onLikeClick: PropTypes.func,
    onClick: PropTypes.func,
    isMultipleSelect: PropTypes.bool,
    isSelected: PropTypes.bool,
    onDownloadClick: PropTypes.func,
    onShareSettingClick: PropTypes.func,
    onVideoEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onSelected: PropTypes.func,
    guestUserInfo: PropTypes.shape({
        guestMode: PropTypes.bool.isRequired,
    }),
};

export default FJCommunityWorkItem;
